import React from 'react';

export default function Camera() {
  return (
    <svg width="44" height="38" viewBox="0 0 44 38">
      <path d="M42,7.15a2.3,2.3,0,0,0-1.2-.62q-2.46-.25-7.37-0.64-1-3.41-1.18-3.81A2.74,2.74,0,0,0,31.38.87,2.32,2.32,0,0,0,30.1.3Q26,0,22,0t-7.91.3a2.32,2.32,0,0,0-1.28.57,2.73,2.73,0,0,0-.88,1.21q-0.15.4-1.18,3.81l-7.32.64a2.32,2.32,0,0,0-1.25.62,2,2,0,0,0-.66,1.16A75.38,75.38,0,0,0,0,21.89,71.49,71.49,0,0,0,1.52,35.23a1.87,1.87,0,0,0,.66,1.14A2.38,2.38,0,0,0,3.44,37,166.67,166.67,0,0,0,22,38a171.53,171.53,0,0,0,18.81-1,2.37,2.37,0,0,0,1.2-.59,2.14,2.14,0,0,0,.71-1.14,71.59,71.59,0,0,0,0-26.92A2.27,2.27,0,0,0,42,7.15ZM9,21a12.51,12.51,0,0,1,3.84-9.16A12.5,12.5,0,0,1,22,8a12.51,12.51,0,0,1,9.16,3.84A12.51,12.51,0,0,1,35,21a12.5,12.5,0,0,1-3.84,9.16A12.51,12.51,0,0,1,22,34a12.5,12.5,0,0,1-9.16-3.84A12.5,12.5,0,0,1,9,21Zm13-8a8,8,0,0,1,8,8,8,8,0,0,1-8,8,8,8,0,0,1-8-8A8,8,0,0,1,22,13Z" />
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/components/icons/Camera/index.js